export default {"src":"/_next/static/media/rbi.49fd4c47.svg","height":160,"width":160};